:host {
  display: block;
  max-width: 100%;
}

.wizard {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: start;
}

gz-wizard-step:first-of-type::part(line) {
  width: 0;
}
